// main.tsx — SPA entrypoint. Mounts <App/> into #root under StrictMode and pulls
// in the global HUD styles. No router yet; the whole experience is one canvas.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
